import React from 'react';

import './style.scss';

class Background extends React.Component {
  render() {
    const className = this.props.blue
      ? 'assessment__background--blue'
      : 'assessment__background';
    return <div className={className} />;
  }
}

export default Background;



// WEBPACK FOOTER //
// ./src/routes/assessment/components/Background/index.js